import MonthYearPicker from '../../../../../../common/_custom/MonthYearPicker/MonthYearPicker';
import Button from '../../../../../../common/_custom/Button/Button';
import styles from './TimePeriodFilter.module.scss';

interface TimePeriodFilterProps {
    startMonth: string;
    endMonth: string;
    startPickerMin: string;
    startPickerMax: string;
    endPickerMin: string;
    endPickerMax: string;
    rangeApplied: boolean;
    onSelectStartMonth: (month: string) => void;
    onSelectEndMonth: (month: string) => void;
    onClear: () => void;
}

// "Time Period:" [MMM-YYYY] to [MMM-YYYY] for the Banking section header.
// Markup pattern: GstAnalysisPanel.tsx's TimePeriodRowRight, WITHOUT the GST range toggle
// including the GST tab's "Reset" button (post-gate addition, see useBankDateRange.clear), which
// only renders once a range is applied — so the default state still shows exactly two chips.
function TimePeriodFilter({
    startMonth,
    endMonth,
    startPickerMin,
    startPickerMax,
    endPickerMin,
    endPickerMax,
    rangeApplied,
    onSelectStartMonth,
    onSelectEndMonth,
    onClear,
}: TimePeriodFilterProps) {
    return (
        <div className={styles.TimePeriodRow}>
            <span className={styles.Label}>Time Period:</span>
            <MonthYearPicker value={startMonth} min={startPickerMin} max={startPickerMax} onChange={onSelectStartMonth} />
            <span className={styles.To}>to</span>
            <MonthYearPicker value={endMonth} min={endPickerMin} max={endPickerMax} onChange={onSelectEndMonth} />
            {rangeApplied && <Button text="Reset" variant="secondary" type="button" className={styles.ResetButton} onClick={onClear} />}
        </div>
    );
}

export default TimePeriodFilter;
